import { z } from "zod";

const localeSchema = z.object({
	name: z.string().trim().min(3, "errors.product_name_must_least_3_characters"),
	description: z.string().trim().min(3, "errors.description_name_must_least_3_characters"),
});

export type LocaleFormData = z.infer<typeof localeSchema>;

export { localeSchema };
